//globalThis
import { createSlice } from "@reduxjs/toolkit";

export const SUPPORTED_LANGUAGES = ["en", "hi", "pa", "te", "ta", "mr", "bn", "kn"];
const LANGUAGE_STORAGE_KEY = "appLanguage";

const getInitialLanguage = () => {
  const stored = globalThis.window?.localStorage?.getItem(LANGUAGE_STORAGE_KEY);
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) return stored;
  return "en";
};

const languageSlice = createSlice({
  name: "language",
  initialState: {
    current: getInitialLanguage(),
    revision: 0,
    isApplying: false,
  },
  reducers: {
    beginLanguageApply: (state) => {
      state.isApplying = true;
    },
    finishLanguageApply: (state) => {
      state.isApplying = false;
    },
    setLanguage: (state, action) => {
      const nextLanguage = action?.payload;
      if (!SUPPORTED_LANGUAGES.includes(nextLanguage)) return;
      if (state.current === nextLanguage) return;
      state.current = nextLanguage;
      state.revision += 1;
      globalThis.window?.localStorage?.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
      if (globalThis.document?.documentElement) {
        globalThis.document.documentElement.lang = nextLanguage;
      }
    },
    bumpLanguageRevision: (state) => {
      state.revision += 1;
    },
  },
});

export const { setLanguage, beginLanguageApply, finishLanguageApply, bumpLanguageRevision } =
  languageSlice.actions;
export default languageSlice.reducer;
